{
  "@context": "https://schema.org",
  "@type": "Game",
  "name": "CS Wheel",
  "alternateName": [
    "cs wheel", "cs go case spinning", "case spinning cs go", "cs2 case spinning",
    "cs go fortune wheel", "fortune wheel cs go", "cs2 fortune wheel", "cs go bonus wheel",
    "bonus wheel cs go", "cs go lucky wheel", "lucky wheel cs go", "wheel game cs", "csgowheel"
  ],
  "description": "Spin the CS Wheel and win skins, bonuses, and other rewards.",
  "url": "https://6cs.fail/en/wheel"
}
